import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenInFull = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z" })
});
export default SvgOpenInFull;
